export { CompanyLogo } from './CompanyLogo';
